import { parseCookies } from '@cian/utils';
import { deleteCookie } from '@cian/utils/lib/browser/cookie';
import { useEffect, useMemo } from 'react';

import { useApplicationContext } from '../utils/applicationContext';

const SKIP_HEADER_BANNERS_COOKIE_CONFIG_KEY = 'skipHeaderBannersCookieName';
const COOKIE_DELETION_TIMEOUT = 100;

/**
 * Возвращает, установлена ли извне шапки кука, указывающая на пропуск баннеров.
 */
export const useIsBannerSkippedByCookie = (): boolean => {
  const { config } = useApplicationContext();

  const cookieName = config.get<string>(SKIP_HEADER_BANNERS_COOKIE_CONFIG_KEY);

  const isSkippedByCookie = useMemo(() => {
    if (typeof document === 'undefined' || !cookieName) {
      return false;
    }

    return parseCookies(window.document.cookie)[cookieName] === '1';
  }, [cookieName]);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isSkippedByCookie) {
      // Ждем, чтобы в первый рендер все баннера успели прочитать куку.
      timeoutId = setTimeout(() => {
        deleteCookie(cookieName as string);
      }, COOKIE_DELETION_TIMEOUT);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [cookieName, isSkippedByCookie]);

  return isSkippedByCookie;
};
